import Invoice from './Invoice.view';

export default Invoice;
